import { action, IObservableValue, observable } from 'mobx';

export class LinkStore {
    // TODO УБРАТЬ ОТСЮДА userInfo
    /**
     * Почему оно здесь?
     * При попытке перенести userInfo в userStore и
     * добавить import userStore в файле authService.js
     * перестают работать страницы, которые используют userStore
     * (ex. Заказы, Биллинг)
     */
    @observable userInfo: IObservableValue<string>;
    @observable html: IObservableValue<string | null>;
    @observable updateLink: IObservableValue<boolean>;
    @observable linkUrl: IObservableValue<string | null>;
    @observable entityKey: IObservableValue<string | null>;
    @observable showAddLinkPanel: IObservableValue<boolean>;

    constructor() {
        this.userInfo = observable.box('');
        this.html = observable.box<string | null>(null);
        this.updateLink = observable.box<boolean>(false);
        this.linkUrl = observable.box<string | null>(null);
        this.entityKey = observable.box<string | null>(null);
        this.showAddLinkPanel = observable.box<boolean>(false);
    }

    @action('get userInfo')
    getUserInfo(): string {
        return this.userInfo.get();
    }

    @action('set userInfo')
    setUserInfo(userInfo: string) {
        this.userInfo.set(userInfo);
    }

    @action('remove userInfo')
    removeUserInfo(): void {
        this.userInfo.set('');
    }

    /**
     * Получить строку в виде html
     */
    @action('get html')
    getHtml = (): string | null => {
        return this.html.get();
    };

    /**
     * Сохранить строку в виде html
     */
    @action('set html')
    setHtml = (html: string | null): void => {
        this.html.set(html);
    };

    /**
     * Получить статус показа панели для добавления ссылки
     */
    @action('get show add link panel')
    getShowAddLinkPanel = (): boolean => {
        return this.showAddLinkPanel.get();
    };

    /**
     * Сохранить статус показа панели для добавления ссылки
     */
    @action('set show add link panel')
    setShowAddLinkPanel = (showAddLinkPanel: boolean): void => {
        this.showAddLinkPanel.set(showAddLinkPanel);
    };

    /**
     * Получить ссылку
     */
    @action('get link url')
    getLinkUrl = (): string | null => {
        return this.linkUrl.get();
    };

    /**
     * Сохранить ссылку
     */
    @action('set link url')
    setLinkUrl = async (linkUrl: string | null): Promise<void> => {
        return this.linkUrl.set(linkUrl);
    };

    /**
     * Получить уникальный ключ ссылки
     */
    @action('get entity key')
    getEntityKey = (): string | null => {
        return this.entityKey.get();
    };

    /**
     * Сохранить уникальный ключ ссылки
     */
    @action('set entity key')
    setEntityKey = async (entityKey: string | null): Promise<void> => {
        return this.entityKey.set(entityKey);
    };

    /**
     * Получить статус обновления ссылки
     */
    @action('get update link')
    getUpdateLink = (): boolean => {
        return this.updateLink.get();
    };

    /**
     * Сохранить статус обновления ссылки
     */
    @action('set update link')
    setUpdateLink = async (updateLink: boolean): Promise<void> => {
        return this.updateLink.set(updateLink);
    };
}

const linkStore = new LinkStore();

export default linkStore;
